document.addEventListener("DOMContentLoaded", function (event) {
    var productGallery = document.querySelector('.product-gallery');
    var recommendedProducts = document.querySelector('.recommended-container');

    var toggleGallery = $('#toggle-image');

    // Force images to load eagerly
    const images = document.querySelectorAll(".product-gallery__image img");
    images.forEach(img => {
        img.setAttribute("loading", "eager");
        img.style.opacity = "1";
    });

    toggleGallery?.on('click', function () {
        if (window.innerWidth < 1180) {
            return;
        }
        var targetDiv = document.querySelector('.product-images-wrapper');
        targetDiv.classList.toggle('expand');

        var mobileProductDetails = document.querySelector('.modal-product-details');
        mobileProductDetails.classList.toggle('move-right');

        var productGallery = document.querySelector('.product-gallery');
        productGallery.classList.toggle('no-padding');
    });

    productGallery?.addEventListener('click', function () {
        if (window.innerWidth < 1180) {
            return;
        }

        var targetDiv = document.querySelector('.product-gallery');
        targetDiv.classList.toggle('full-size');

        var productOverlay = document.querySelector('.recommended-container');
        productOverlay.classList.toggle('move-left');

        var productOverlayWidth = document.querySelector('#product-overlays');
        productOverlayWidth.classList.toggle('move-width');

        var productDetails = document.querySelector('.product-details');
        productDetails.classList.toggle('move-right');
    });
});
